import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {CaConfigComponent} from "../component/protected-components/config/ca-config.component";


const caModuleEntry: TestModuleDefinition = {
    key: 'ca',
    label: 'Assessment (ca)',
    components: [

        {
            key: 'CaConfigComponent',
            component: CaConfigComponent,
            selector: 'ca-config',
            type: 'PageComponent',
            label: 'ca config'
        },
    ]
}

export const CA_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: caModuleEntry, multi: true}
];